<template>
  <div>
    <v-dialog v-model="dialog"
              persistent
              scrollable
              width="500"
    >

      <form @submit.prevent="saveBoosting">
        <v-card :disabled="isLoading" :loading="isLoading">

          <v-card-title>
            Générer des codes
            <v-spacer/>
            <v-icon @click="close">mdi-close</v-icon>
          </v-card-title>
          <v-divider/>

          <v-card-text class="pa-8">

            <v-text-field v-model="name"
                          :error-messages="errors.name"
                          label="Nom de la campagne *"/>

            <v-radio-group v-model="type"
                           row
                           :error-messages="errors.type"
                           label="Type des codes *">
              <v-radio label="Alphanumérique" value="character"></v-radio>
              <v-radio label="Numérique" value="digital"></v-radio>
            </v-radio-group>

            <v-text-field v-model="nb_characters"
                          v-number
                          :error-messages="errors.nb_characters"
                          label="NB de Caractères *"
                          type="number"/>


            <v-text-field v-model="nb_codes"
                          v-number
                          :error-messages="errors.nb_codes"
                          label="NB de Codes *"
                          type="number"/>

          </v-card-text>

          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn :loading="isLoading"
                   color="primary"
                   depressed
                   type="submit">
              <v-icon left>mdi-content-save</v-icon>
              Sauvgarder
            </v-btn>
          </v-card-actions>

        </v-card>
      </form>

    </v-dialog>
  </div>
</template>

<script>

import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      dialog: false,
      isLoading: false,
      errors: {},

      name: '',
      type: 'character',
      nb_characters: 10,
      nb_codes: 100,
    }
  },
  methods: {
    open() {
      this.dialog = true
      this.name = ''
      this.nb_characters = 10
      this.nb_codes = 100
      this.errors = {}
    },
    close() {
      this.dialog = false
    },
    saveBoosting() {
      this.errors = {}
      this.isLoading = true
      HTTP.post('/v1/boostings/store', {
        name: this.name,
        type: this.type,
        nb_characters: this.nb_characters,
        nb_codes: this.nb_codes,
      }).then(() => {
        this.isLoading = false
        this.dialog = false
        this.$emit('refresh')
        this.$successMessage = "Le processus a été enregistré avec succès. Tous les codes seront générés en plus tard."
      }).catch(err => {
        this.isLoading = false
        this.errors = err.response.data.errors
        this.$errorMessage = "Une erreur s'est produite veuillez corriger et réessayer."
        console.log(err)
      })

    },
  },
}
</script>

